export default {
  memberInfo: {
    name: 'name',
    accout: 'accout',
    cellphone: 'cellphone',
    email: 'email'
  },
  edit: 'edit',
  appresponsiberInfo: {
    title: 'Application owner',
    tip: 'Has Everyone permission to this app, up to 5 people'
  },
  collaborativeDevInof: {
    title: 'Co-developers',
    tip: 'You can only view the information of the application and submit the development version. You can set up to 50 people.'
  }
};
